import { Textarea } from "@/components/ui/textarea";

interface PlanDescriptionInputProps {
  description: string;
  onChange: (value: string) => void;
}

export const PlanDescriptionInput = ({ description, onChange }: PlanDescriptionInputProps) => {
  return (
    <Textarea
      placeholder="Descripción (opcional)"
      value={description}
      onChange={(e) => onChange(e.target.value)}
      className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
    />
  );
};